import { DthSessionStorage } from "../dth/clientHttp/DthSessionStorage";
import { CONTACT_FORMAT_CAN_CHANGE_DISPLAY_NAME_IN_CHAT } from "../dth/constants";
import { ContactFormatEnum } from "../dth/ContactFormatEnum";
import { formatDisplayName, getContactFormatOrDefault, getContactNameFormat } from "../dth/utils";
import { ContactStateManager } from "./ContactStateManager";

export interface UserIdentifierCustomisations {
    /**
     * Customise display of the user identifier
     * hide userId for guests, display 3pid
     *
     * Set withDisplayName to true when user identifier will be displayed alongside user name
     */
    getDisplayUserIdentifier(userId: string, opts: {
        roomId?: string;
        withDisplayName?: boolean;
        withEmail?: boolean;
    }): string | null;
}

/**
 * Customise display of the user identifier
 * hide userId for guests, display 3pid
 *
 * Set withDisplayName to true when user identifier will be displayed alongside user name
 */
function getDisplayUserIdentifier(
    userId: string,
    { roomId, withDisplayName, withEmail }: { roomId?: string; withDisplayName?: boolean, withEmail?: boolean },
): string | null {
    // return userId;
    let displayName: string = userId;
    if (withDisplayName) {
        // prova a recuperare il contatto per ottenere nome e email
        const contact = ContactStateManager.getContactByMatrixName(userId);
        // prelievo configurazione contact_format se abilitata
        const contactFormat: ContactFormatEnum | null =
            CONTACT_FORMAT_CAN_CHANGE_DISPLAY_NAME_IN_CHAT ? getContactFormatOrDefault() : null;
        let name: string | undefined;
        let email: string | undefined;
        // se c'è un contatto, usa quello, altrimenti se è l'utente corrente usa le sue info, altrimenti lascia solo userId
        if (contact) {
            // se c'è contatto associato, usa quello per nome e email
            name = getContactNameFormat(contact, contactFormat);
            email = contact?.email;
        } else {
            // se non c'è contatto associato, ma è l'utente corrente, usa le sue info per nome e email
            const currentUser = DthSessionStorage.getCurrentUserInfo();
            if (currentUser && currentUser.matrixName === userId) {
                name = formatDisplayName(currentUser.firstName, currentUser.lastName, contactFormat);
                email = currentUser.email;
            }
        }

        // se ho un nome e devo mostrare anche l'email, mostro entrambi, altrimenti solo il nome (o userId se non ho il nome)
        if (name && withEmail && email) {
            displayName = `${name} (${email})`;
        } else if (name) {
            displayName = name;
        }
    }
    return displayName;
}

// A real customisation module will define and export one or more of the
// customisation points that make up `IUserIdentifierCustomisations`.
export default {
    getDisplayUserIdentifier,
} as UserIdentifierCustomisations;
